import React from 'react';
import {useLocalization} from 'localization';
import {FlexBox} from 'components';

export const WorkCardTitle: React.FC = () => {
  const {t} = useLocalization();

  return (
    <FlexBox alignItems={'center'} horizontal>
      {t('page.metadata.work.title')}
    </FlexBox>
  );
};
